<div class="modal-header">
  <h6 class="modal-title" i18n>Listing Settings</h6>
  <a (click)="close()" class="cstm-close">
    <span class="far fa-times"></span>
  </a>
</div>
<div class="modal-body">
  <div class="webready-banner mb-3" *ngIf="!form.get('isCustomWebsite').value">
    <img src="https://cdn.tokeet.com/images/Appstore_logos/webready.svg" alt="Webready Logo" />
    <div>
      <ng-container i18n>Webready is the most advanced website builder in the industry.</ng-container>
      <a [href]="storeLink" target="_blank" i18n>Try it now!</a>
    </div>
  </div>
  <div class="mb-3">
    <form [formGroup]="form">
      <div class="row">
        <!-- Checkbox always shown at the top -->
        <div class="col-sm-12 mb-3">
          <mat-checkbox formControlName="isCustomWebsite" i18n>
            This listing uses a custom website (external)
          </mat-checkbox>
        </div>

        <!-- Custom listing URL — shown when checkbox is checked and a tokeet website is selected -->
        <ng-container *ngIf="form.get('isCustomWebsite')?.value">
          <div class="col-sm-12 mb-3">
            <mat-form-field2 class="mat-block">
              <input
                type="text"
                formControlName="customListingUrl"
                matInput
                placeholder="Full Listing URL"
                i18n-placeholder
              />
              <mat-hint class="d-block mt-1" i18n>Optional — override the "View website" link shown on Google</mat-hint>
            </mat-form-field2>
          </div>
        </ng-container>

        <!-- Website (landing page) dropdown — filtered by checkbox state -->
        <div [ngClass]="isDomainDisabled ? 'col-sm-12' : 'col-sm-6'">
          <mat-form-field2 class="mat-block">
            <app-select
              [items]="websites$ | async"
              bindLabel="name"
              bindValue="id"
              groupBy="provide"
              formControlName="websiteId"
              placeholder="Website (Landing Page)"
              i18n-placeholder
              class="mat-block"
              [required]="true"
            >
            </app-select>
          </mat-form-field2>
        </div>

        <!-- Webready domain selector (only when a webready website is selected) -->
        <div class="col-sm-6" *ngIf="!isDomainDisabled">
          <mat-form-field2 class="mat-block">
            <app-select
              [items]="domains$ | async"
              bindLabel="_id"
              bindValue="_id"
              formControlName="websiteDomainId"
              placeholder="Webready Website Domain"
              i18n-placeholder
              class="mat-block"
              [disabled]="isDomainDisabled"
              [required]="isDomainRequired"
            >
            </app-select>
          </mat-form-field2>
        </div>

        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="websiteDisplayName"
              matInput
              placeholder="Website Display Name"
              i18n-placeholder
            />
            <mat-hint i18n>Rental display name will be used, if this isn't set</mat-hint>
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <mat-select
              formControlName="cancellationPolicyType"
              placeholder="Cancellation Policy Type"
              i18n-placeholder
            >
              <mat-option value="No Refund" i18n>No Refund</mat-option>
              <mat-option value="Strict" i18n>Strict</mat-option>
              <mat-option value="Firm" i18n>Firm</mat-option>
              <mat-option value="Moderate" i18n>Moderate</mat-option>
              <mat-option value="Relaxed" i18n>Relaxed</mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
        <div class="col-sm-12 text-right" *ngIf="form.get('websiteId').value">
          <button (click)="onCheckWebsiteData()" type="button" class="btn btn-outline-primary">
            <span class="fal fa-check-circle"></span>
            <ng-container i18n>Check Website Data</ng-container>
          </button>
          <button (click)="onPublishWebsite()" type="button" class="btn btn-secondary-info ml-3">
            <span class="cs-icon cs-icon-upload"></span>
            <ng-container i18n>Publish Website</ng-container>
          </button>
        </div>
      </div>
    </form>
  </div>
  <ng-container *ngIf="errors.length">
    <div class="alert alert-warning" i18n>
      Please publish your website to fix these errors after updating rental data.
    </div>

    <div class="validation-box">
      <div class="validation-list">
        <div *ngFor="let error of errors" class="invalid-item">
          <i class="fas fa-exclamation-circle" [ngClass]="error.type"></i>
          <ng-container *ngFor="let e of error.errors">{{ e }}</ng-container>
          <a href="javascript:;" (click)="onFixRental(error)" class="fix-btn text-uppercase">
            <ng-container i18n>fix it</ng-container> <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
          </a>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline-light">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="onSave(form)"
    type="button"
    class="btn btn-secondary-info"
    [disabled]="isLoading || isLoadingWebsites"
  >
    <span class="cs-icon cs-icon-save" *ngIf="!isLoading && !isLoadingWebsites"></span>
    <span *ngIf="isLoading || isLoadingWebsites" class="far fa-spinner fa-spin"></span>
    <ng-container i18n>Save</ng-container>
  </button>
</div>
